export * from './M75MediaText';
export { M75MediaText as default } from './M75MediaText';
